<div class="card">
  <div class="card-body">
    <p class="mb-4">
      {{ (isSampleExam ? "EXAM.SUMMARY.SAMPLE.INFO_1" : "EXAM.SUMMARY.INFO_1") | translate: {stageName: session?.chapterName} }}
    </p>
    <div class="table-responsive mb-2">
      <table class="table white-text table-borderless text-center">
        <thead>
        <tr class="table-row table-row-head">
          <th class="small">{{ 'EXAM.TABLE_HEADER.PART' | translate }}</th>
          <th class="small">{{ 'EXAM.TABLE_HEADER.TASK' | translate }}</th>
          <th class="small">{{ 'EXAM.TABLE_HEADER.SCORE' | translate }}</th>
        </tr>
        </thead>
        <tbody class="table-body">
        <tr *ngFor="let part of sessionParts; index as i" class="table-row">
          <td class="small text-nowrap">{{ i + 1 }}</td>
          <td class="small">{{ part.partName }}</td>
          <td class="small">{{ part.score ? (part.score | percent:'1.0-0') : '-' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex align-items-center mb-3 justify-content-center">
      <p class="me-3"> 
        {{ "EXAM.SUMMARY.TOTAL_SCORE_INFO" | translate }} {{(getTotalScore() | percent:'1.0-0')}}
      </p>
      <button
        *ngIf="!isSampleExam"
        type="button"
        class="btn btn-outline-primary rounded-pill btn-sm mb-3"
        (click)="scoreInfoModal.show()"
      >
        <app-icon class="icon-blue" name="question-mark"></app-icon>
      </button>
    </div>
    <p>
      {{ (isSampleExam ? "EXAM.SUMMARY.SAMPLE.INFO_2" : "EXAM.SUMMARY.INFO_2") | translate }}
    </p>
  </div>
  <div class="card-footer border-0 text-center px-4 pb-3">
    <button type="button"
            routerLink="../../../../../"
            class="btn btn-primary rounded-pill mx-auto py-2 px-5"
           >
      {{ 'BUTTON.FINISH' | translate }}
    </button>
  </div>
</div>

<app-modal #scoreInfoModal>
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "EXAM.SUMMARY.SCORE_INFO.TITLE" | translate }}</h5>
      <button type="button"
              class="btn btn-close btn-close-white"
              (click)="scoreInfoModal.hide()"
              aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getStageRange() + '.INFO_1' | translate }}</p>
      <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getStageRange() + '.INFO_2' | translate }}</p>
      <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getStageRange() + '.INFO_3' | translate }}</p>
      <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getStageRange() + '.INFO_4' | translate }}</p>
    </div>
  </div>

</app-modal>
